<template>
	<div id="ssr_root">
        <div class="row">
            <div class="col-xs-12 m-b-15">
                <breadcrumbs></breadcrumbs>
            </div>
        </div>
        <div class="row">
            <sponsored-ads :location="location"></sponsored-ads>
			<div class="col-xs-12" itemscope itemtype="http://schema.org/ItemList">
				<div class="text-center" v-if="properties.length == 0 && loading == false">
                    <empty-section></empty-section>
				</div>
                <div class="row">
                    <slot v-for="(ad, index) in properties">
                        <div v-if="index === 0 && properties[0].weight < 1 && pagination.current_page === 1">
                            <empty-section></empty-section>
                        </div>

                        <div v-if="index > 0 && parseInt(properties[index - 1].weight) === 1 && parseInt(ad.weight) < 1" class="col-xs-12 m-b-15">
                            <divider></divider>
                        </div>

                        <article :key="ad.id">
                            <property-ad-card :ad="ad" :index="pagination.from + index" />
                        </article>
                    </slot>
                </div>
                <vue-simple-spinner v-if="loading"></vue-simple-spinner>
                <!-- Sentinel element for infinite scroll -->
                <div ref="sentinel" v-show="button_visibility" style="height: 20px;"></div>
			</div>

			<div class="col-xs-12" v-show="button_visibility && !loading">
				<div class="text-center">
					<vue-simple-pagination v-bind:pagination="pagination" @changePage="loadMore"></vue-simple-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SimpleSpinner from '../spinner/Spinner.vue';
    import SimplePagination from '../pagination/simple.vue';
    import SponsoredAds from './sponsored-ads.vue';
    import PropertyAdCard from './property-ad-card.vue';
    import Breadcrumbs from './filters/breadcrumbs.vue';
    import PropertyCardDivider from './property-card-divider.vue';
    import PropertyAdEmptySearch from './property-ad-empty-search.vue';

	export default {
		components: {
			'vue-simple-spinner': SimpleSpinner,
            'vue-simple-pagination': SimplePagination,
            'sponsored-ads': SponsoredAds,
            'property-ad-card': PropertyAdCard,
            'breadcrumbs': Breadcrumbs,
            'divider': PropertyCardDivider,
            'empty-section': PropertyAdEmptySearch
		},
		computed: {
            button_visibility() {
                return this.$store.state.button_visibility;
            },
            loading() {
                return this.$store.state.loading;
            },
			properties() {
				return this.$store.getters.getAds;
			},
			pagination() {
				return this.$store.getters.getPagination;
			},
			location() {
				return this.$store.getters.getCityName;
			},
            filter() {
                return this.$store.getters.getFilter;
            },
            search_type() {
                return this.$store.state.search_type;
            },
		},
		methods: {
            registerSearchEvent() {
                window.dataLayer.push({
                    event: 'search',
                    event_category: 'search_page',
                    event_label: 'search_results',
                    search_location: this.location,
                    search_type: this.search_type,
                    search_results: this.properties.length
                });
            },
            loadMore() {
                if (!this.loading && this.button_visibility) {
                    this.$store.commit('setPage', ++this.pagination.current_page);
                    this.$store.dispatch('replaceUrl');
                    this.$store.dispatch('filterResults', true).then(() => {
                        this.registerSearchEvent();
                    });
                }
            },
            setupIntersectionObserver() {
                const options = {
                    root: null,
                    rootMargin: '450px',
                    threshold: 0.1
                };

                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting && !this.loading) {
                            this.loadMore();
                        }
                    });
                }, options);

                if (this.$refs.sentinel) {
                    observer.observe(this.$refs.sentinel);
                }

                return observer;
            }
		},
        mounted() {
            this.observer = this.setupIntersectionObserver();
        },
        beforeDestroy() {
            if (this.observer) {
                this.observer.disconnect();
            }
        },
        created() {
            this.registerSearchEvent();

            if (this.properties.length === 0) {
                this.$store.commit('setButtonVisibility', false);
            }
        }
	}
</script>
